import React, { ComponentProps } from 'react';

import { ActivityCard } from '@adsk/alloy-react-activity-log';
import { Flex, Text } from '@adsk/alloy-react-box';

import { useTranslation } from '../i18n';

type ReferenceActivityCardNoPermissionProps = ComponentProps<
  typeof ActivityCard
>;

/**
 * This component shows indication that the user has no permissions to see the referenced entity.
 */
const ReferenceActivityCardNoPermission: React.ForwardRefExoticComponent<
  ReferenceActivityCardNoPermissionProps & React.RefAttributes<HTMLDivElement>
> = React.forwardRef<HTMLDivElement, ReferenceActivityCardNoPermissionProps>(
  (props, ref) => {
    const { t } = useTranslation();

    return (
      <ActivityCard ref={ref} {...props}>
        <Flex alignItems="center">
          <Text typography="bodySmall" color="charcoal700">
            {t('ACTIVITY_NO_PERMISSIONS')}
          </Text>
        </Flex>
      </ActivityCard>
    );
  },
);

ReferenceActivityCardNoPermission.displayName =
  'ReferenceActivityCardNoPermission';

export default ReferenceActivityCardNoPermission;
